import React, { useRef, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../contexts/hooks';
import { ToolbarSimple } from '../../components';
import { setModalBarcodePrintersVisible } from '../../contexts/slices/config';
import { ScrollView } from 'devextreme-react';

export default function ConexionesContenedora() {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // Estados
  const [apiCreateOrderUrl, setApiCreateOrderUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const token = useAppSelector((state) => state.userInfo.Token) || '';
  const apiConsultOrderUrl = useAppSelector((x) => x.configuration.Data?.Config_General.find((cfg) => cfg.Cgn_Nombre === 'ExternalEndPointBackEnd')?.Cgn_Resultado);
  const microFrontEndUrl = useAppSelector((x) => x.configuration.Data?.Config_General.find((cfg) => cfg.Cgn_Nombre === 'ExternalEndPointFrontEnd')?.Cgn_Resultado);
  const ExternalAppName = useAppSelector((x) => x.configuration.Data?.Config_General.find((cfg) => cfg.Cgn_Nombre === 'ExternalAppName')?.Cgn_Resultado);
  const Prm_CodBarImprimir = useAppSelector((x)=>x.userInfo.Permissions?.Prm_CodBarImprimir);
  const moduleBarcodeRaw = useAppSelector((x) => x.configuration.Data?.Config_General.find((cfg) => cfg.Cgn_Nombre === 'ModuleBarcode')?.Cgn_Resultado);
  const automaticBarcodePrintRaw = useAppSelector((x) => x.configuration.Data?.Config_General.find((cfg) => cfg.Cgn_Nombre === 'AutomaticBarcodePrint')?.Cgn_Resultado);
  const moduleBarcode = moduleBarcodeRaw ? JSON.parse(moduleBarcodeRaw) : false;
  const automaticBarcodePrint = automaticBarcodePrintRaw ? JSON.parse(automaticBarcodePrintRaw) : false;
  const modalBarcodePrintersVisible = useAppSelector((state) => state.configuration.ModalBarcodePrintersVisible);

  const [printer, setPrinter] = useState('');
  const dispatch = useAppDispatch();

  // Fetch inicial para obtener apiCreateOrderUrl
  useEffect(() => {
    async function fetchApiCreateOrderUrl() {
      try {
        const configUrl = '/config.json';
        const configResponse = await fetch(configUrl);
        const config = await configResponse.json();
        const apiUrl = `${config.apiUrl}`;
        setApiCreateOrderUrl(apiUrl);
      } catch (error) {
        console.error('Error fetching apiCreateOrderUrl:', error);
        setApiCreateOrderUrl(null);
      } finally {
        setIsLoading(false);
      }
    }

    fetchApiCreateOrderUrl();
  }, []);

  useEffect(() => {
    if (moduleBarcode) {
      const stored = localStorage.getItem('defaultPrinter');
      if (!stored) {
        if(Prm_CodBarImprimir){          
          dispatch(setModalBarcodePrintersVisible(true));
        }
      } else {
        setPrinter(JSON.parse(stored).Cbp_Url || '');
      }
    } else {
      setPrinter('');
    }
  }, [moduleBarcode, modalBarcodePrintersVisible]);

  useEffect(() => {
    function handleMessageFromChild(event: MessageEvent) {
      const data = event.data;
      if (data?.type === 'CHILD_READY') {
        const payload = {
          token,
          apiCreateOrderUrl,
          apiConsultOrderUrl,
          printer,
          moduleBarcode,
          automaticBarcodePrint,
        };
        (event.source as Window).postMessage(payload, { targetOrigin: event.origin });
      }
    }

    window.addEventListener('message', handleMessageFromChild);
    return () => {
      window.removeEventListener('message', handleMessageFromChild);
    };
  }, [token, apiCreateOrderUrl, apiConsultOrderUrl, printer, moduleBarcode, automaticBarcodePrint]);

  const iframeSrc = microFrontEndUrl ? `${microFrontEndUrl}?_ts=${Date.now()}` : '';

  if (isLoading) {
    return <div>Cargando...</div>;
  }

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <ScrollView className='view-wrapper-scroll' style={{ flex: 1 }}>
        <ToolbarSimple title={ExternalAppName || 'N/A'}>
          {iframeSrc ? (
            <iframe
              ref={iframeRef}
              src={iframeSrc}
              style={{
                border: 'none',
                width: '100%',
                height: '100%',
                flex: 1,
              }}
            />
          ) : (
            <div>No hay URL para el microfrontend</div>
          )}
        </ToolbarSimple>
      </ScrollView>
    </div>
  );
}
